import { numberToAlphabet } from '../../../../utils';

export const SSPollResultLabel = ({ index }: { index: number }) => (
    <span className="inline-block capitalize font-medium text-lg mr-4 ml-2">{numberToAlphabet(index)}</span>
);
